"use client";
import { pxToRem } from "@/util";
import { Box, Button, Checkbox, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { AppColors } from "@/assets/colors";
import Link from "next/link";

export default function InputForm() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const { classes } = styles();

  // Form state
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

 const handleSendEmail = () => {
  const emailBody = `Full Name: ${firstName} ${lastName}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`;
  const mailtoLink = `mailto:Info@arelhomesng.com?subject=${encodeURIComponent('Contact Form Submission')}&body=${encodeURIComponent(emailBody)}`;
  window.location.href = mailtoLink;
};


  return (
    <Box className={`${classes.container}`}>
      <Box className={`${classes.form1}`}>
        <Box className={`${classes.input}`}>
          <Typography className={`${classes.label}`}>First Name</Typography>
          <TextField
            placeholder="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </Box>
        <Box className={`${classes.input}`}>
          <Typography className={`${classes.label}`}>Last Name</Typography>
          <TextField
            placeholder="Last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </Box>
        <Box className={`${classes.input}`}>
          <Typography className={`${classes.label}`}>Email</Typography>
          <TextField
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
        <Box className={`${classes.input}`}>
          <Typography className={`${classes.label}`}>Phone Number</Typography>
          <TextField
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </Box>
      </Box>

      <Box className={`${classes.form3}`}>
        <Box className={`${classes.input}`}>
          <Typography className={`${classes.label}`}>Message</Typography>
          <TextField
            placeholder="Info"
            multiline
            rows={5}
            variant="outlined"
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Box>
      </Box>

      <Box className={`${classes.form4}`}>
        <Box className={`${classes.check}`}>
          <Checkbox {...label} />
          <Typography>
            I agree with{" "}
            <Link
              href="/privacy"
              target="_blank"
              className={classes.link}
              prefetch
            >
              Arel Privacy Policy
            </Link>
          </Typography>
        </Box>
        <Button
          variant="contained"
          fullWidth={false}
          className={`${classes.btn}`}
          onClick={handleSendEmail}
        >
          Send a message
        </Button>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100%",
  },
  debug: {
    border: "1px solid red",
  },
  link: {
    color: "#1A35DF",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  label: {
    fontWeight: 500,
    fontSize: pxToRem(14),
  },
  form1: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  form2: {
    display: "grid",
    gridTemplateColumns: "2fr 2fr",
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  form3: {
    marginBottom: theme.spacing(2),
  },
  form4: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  check: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  good: {
    border: `1px solid ${AppColors.neutral["65"]}`,
  },
  btn: {
    width: pxToRem(170),
    height: pxToRem(46),
  },
}));
